import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AuthService } from '@core/auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AppComponent implements OnInit {
  private readonly authService = inject(AuthService);

  readonly authIsLoading$: Observable<boolean> = this.authService.isLoading$;

  ngOnInit(): void {
    this.loginRequired();
  }

  private loginRequired(): void {
    this.authService
      .loginRequired()
      .pipe(switchMap(() => this.authService.login()))
      .subscribe();
  }
}
